import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import { MESSAGE_FIELDS } from '#graphql/fragments/message-fields';
import type {
  UpdateMessageMutation,
  UpdateMessageMutationVariables,
} from '#graphql/generated';

export const UPDATE_MESSAGE: TypedDocumentNode<
  UpdateMessageMutation,
  UpdateMessageMutationVariables
> = gql`
  ${MESSAGE_FIELDS}
  mutation UpdateMessage($input: UpdateMessageInput!) {
    updateMessage(input: $input) {
      ...MessageFields
    }
  }
`;
